(() => {
  if (window.lusupCartSignatureGiftReady) return;
  window.lusupCartSignatureGiftReady = true;

  const selectors = {
    root: '[data-cart-signature-gift]',
    item: '[data-cart-signature-gift-item]',
    toggle: '[data-cart-signature-gift-toggle]',
    messageToggle: '[data-cart-signature-gift-message-toggle]',
    messageChoice: '[data-cart-signature-gift-message-choice]',
    panel: '[data-cart-signature-gift-message-panel]',
    message: '[data-cart-signature-gift-message]',
    count: '[data-cart-signature-gift-count]',
    save: '[data-cart-signature-gift-save]',
    error: '[data-cart-signature-gift-error]',
    summary: '[data-lusup-cart-summary]',
    infoOpen: '[data-cart-gift-info-open]',
    infoDialog: '[data-cart-gift-info-dialog]',
    modalClose: '[data-cart-gift-modal-close]',
    removeProduct: '[data-cart-parent-remove]',
    paymentGuard: '[data-cart-gift-payment-guard]',
    dynamicCheckout: '.cart__dynamic-checkout-buttons',
  };

  const checkoutSelector = [
    '[name="checkout"]',
    '.cart__checkout-button',
    '[data-testid="Checkout-button"]',
    '.shopify-payment-button__button',
    '[data-shopify-buttoncontainer] button',
  ].join(',');

  const messageLimit = 60;
  const getCharacters = (value) => Array.from(value || '');
  const hasUnsupportedCharacters = (value) => /[\uD800-\uDFFF]|[\u2600-\u27BF]/.test(value);

  const routeWithJson = (route, fallback) => {
    const value = route || fallback;
    return /\.js(\?|$)/.test(value) ? value : `${value}.js`;
  };

  const routes = () => window.routes || {};
  const cartAddUrl = () => routeWithJson(routes().cart_add_url, '/cart/add');
  const cartChangeUrl = () => routeWithJson(routes().cart_change_url, '/cart/change');
  const cartUpdateUrl = () => routeWithJson(routes().cart_update_url, '/cart/update');
  const cartJsonUrl = () => routeWithJson(routes().cart_url, '/cart');

  const requestJson = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });
    const result = await response.json();

    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'カートを更新できませんでした。');
    }

    return result;
  };

  const getItem = (element) => element?.closest(selectors.item);
  const getRoot = (element) => element?.closest(selectors.root);

  const setCartError = (message = '') => {
    const error = document.getElementById('cart-errors');
    if (!error) return;
    error.textContent = message;
  };

  const setError = (item, message = '') => {
    const error = item?.querySelector(selectors.error);
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  };

  const setBusy = (item, busy) => {
    if (!item) return;
    item.classList.toggle('is-busy', busy);
    item.setAttribute('aria-busy', busy ? 'true' : 'false');
    item.querySelectorAll('input, textarea, button').forEach((control) => {
      if (busy) {
        if (!control.disabled) control.dataset.cartGiftBusyDisabled = 'true';
        control.disabled = true;
      } else if (control.dataset.cartGiftBusyDisabled === 'true') {
        control.disabled = false;
        delete control.dataset.cartGiftBusyDisabled;
      }
    });
  };

  const updateCount = (item) => {
    const message = item?.querySelector(selectors.message);
    const count = item?.querySelector(selectors.count);
    if (!message || !count) return;

    const characters = getCharacters(message.value);
    if (characters.length > messageLimit) {
      message.value = characters.slice(0, messageLimit).join('');
    }
    const nextCount = String(getCharacters(message.value).length);
    if (count.textContent !== nextCount) count.textContent = nextCount;
  };

  const syncMessageRequirement = (item) => {
    const toggle = item?.querySelector(selectors.toggle);
    const messageToggle = item?.querySelector(selectors.messageToggle);
    const message = item?.querySelector(selectors.message);
    if (!message) return;
    message.required = Boolean(toggle?.checked && messageToggle?.checked);
  };

  const syncMessageVisibility = (item) => {
    const giftSelected = Boolean(item?.querySelector(selectors.toggle)?.checked);
    const messageSelected = Boolean(giftSelected && item?.querySelector(selectors.messageToggle)?.checked);
    const messageChoice = item?.querySelector(selectors.messageChoice);
    const panel = item?.querySelector(selectors.panel);

    if (messageChoice) messageChoice.hidden = !giftSelected;
    if (panel) panel.hidden = !messageSelected;
    syncMessageRequirement(item);
  };

  const isPending = (item) => {
    if (item.dataset.requestPending === 'true') return true;

    const toggle = item.querySelector(selectors.toggle);
    if (!toggle?.checked) return false;

    const hasSavedGift = Boolean(item.dataset.giftLineKey);
    if (!hasSavedGift) return true;

    const messageToggle = item.querySelector(selectors.messageToggle);
    if (!messageToggle?.checked) return false;

    const message = item.querySelector(selectors.message)?.value.trim() || '';
    return item.dataset.dirty === 'true' || !message;
  };

  const getPendingItem = () => Array.from(document.querySelectorAll(selectors.item)).find(isPending);

  const openDialog = (dialog) => {
    if (!dialog) return;
    try {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    } catch (error) {
      dialog.setAttribute('open', '');
    }
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  const formatCartMoney = (cents, summary, withCurrency = false) => {
    const currency = summary?.dataset.currency || 'JPY';
    const locale = summary?.dataset.locale || document.documentElement.lang || 'ja';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: withCurrency ? 'symbol' : 'narrowSymbol',
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `¥${Math.round((Number(cents) || 0) / 100).toLocaleString('ja-JP')}`;
    }
  };

  const updateOrderSummary = (hasPendingGift = Boolean(getPendingItem())) => {
    const summary = document.querySelector(selectors.summary);
    if (!summary) return;

    let selectedGiftCount = 0;
    let selectedGiftTotal = 0;

    document.querySelectorAll(selectors.root).forEach((root) => {
      const giftPrice = Number.parseInt(root.dataset.giftPrice || '0', 10) || 0;
      root.querySelectorAll(selectors.item).forEach((item) => {
        if (!item.querySelector(selectors.toggle)?.checked) return;
        selectedGiftCount += 1;
        selectedGiftTotal += giftPrice;
      });
    });

    const savedGiftTotal = Number.parseInt(summary.dataset.savedGiftTotal || '0', 10) || 0;
    const cartTotal = Number.parseInt(summary.dataset.cartTotal || '0', 10) || 0;
    const previewTotal = cartTotal - savedGiftTotal + selectedGiftTotal;
    const giftRow = summary.querySelector('[data-cart-gift-summary-row]');
    const giftCount = summary.querySelector('[data-cart-gift-count]');
    const giftTotal = summary.querySelector('[data-cart-gift-total]');
    const total = summary.querySelector('[data-cart-preview-total]');
    const checkoutTotal = summary.querySelector('[data-cart-checkout-total]');
    const pendingBadge = summary.querySelector('[data-cart-gift-pending-badge]');
    const pendingHelp = summary.querySelector('[data-cart-gift-pending-help]');

    if (giftRow) giftRow.hidden = selectedGiftCount < 1;
    if (giftCount) giftCount.textContent = String(selectedGiftCount);
    if (giftTotal) giftTotal.textContent = formatCartMoney(selectedGiftTotal, summary);
    if (total) total.textContent = formatCartMoney(previewTotal, summary, true);
    if (checkoutTotal) checkoutTotal.textContent = formatCartMoney(previewTotal, summary);
    if (pendingBadge) pendingBadge.hidden = !hasPendingGift;
    if (pendingHelp) pendingHelp.hidden = !hasPendingGift;
  };

  const updateCheckoutState = () => {
    const blocked = Boolean(getPendingItem());
    document.body.classList.toggle('cart-gift-has-pending', blocked);
    document.body.classList.remove('cart-gift-needs-decision');

    document.querySelectorAll(checkoutSelector).forEach((control) => {
      if (blocked) {
        if (!control.hasAttribute('data-cart-gift-original-aria-disabled')) {
          control.dataset.cartGiftOriginalAriaDisabled = control.getAttribute('aria-disabled') || '';
        }
        control.setAttribute('aria-disabled', 'true');
        control.classList.add('cart-gift-checkout-blocked');
        return;
      }

      if (control.hasAttribute('data-cart-gift-original-aria-disabled')) {
        const originalValue = control.dataset.cartGiftOriginalAriaDisabled;
        if (originalValue) {
          control.setAttribute('aria-disabled', originalValue);
        } else {
          control.removeAttribute('aria-disabled');
        }
        delete control.dataset.cartGiftOriginalAriaDisabled;
      }
      control.classList.remove('cart-gift-checkout-blocked');
    });

    document.querySelectorAll(selectors.dynamicCheckout).forEach((container) => {
      let guard = container.querySelector(selectors.paymentGuard);

      if (!guard && blocked) {
        guard = document.createElement('button');
        guard.type = 'button';
        guard.className = 'cart-gift-payment-guard';
        guard.dataset.cartGiftPaymentGuard = '';
        guard.setAttribute('aria-label', 'ギフト設定を確認してからお支払い方法を選択してください');
        container.appendChild(guard);
      }

      if (guard) guard.hidden = !blocked;
    });

    updateOrderSummary(blocked);
  };

  const showPendingError = () => {
    const item = getPendingItem();
    if (!item) return false;

    setError(item, 'メッセージを入力し、ギフト設定を保存してから購入手続きへお進みください。');
    item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    item.querySelector(selectors.message)?.focus({ preventScroll: true });
    return true;
  };

  const guardCheckout = () => showPendingError();

  const removeParentProduct = async (removeControl) => {
    const parentKey = removeControl?.dataset.parentKey || '';
    if (!parentKey) {
      window.location.assign(removeControl?.href || routes().cart_url || '/cart');
      return;
    }

    const row = removeControl.closest('.cart-item');
    row?.classList.add('is-removing');
    removeControl.setAttribute('aria-disabled', 'true');
    setCartError();

    try {
      const response = await fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('カート情報を取得できませんでした。');
      const cart = await response.json();
      const updates = {};

      cart.items.forEach((cartItem) => {
        const linkedParentKey = cartItem.properties?._lusup_parent_key || '';
        if (cartItem.key === parentKey || linkedParentKey === parentKey) {
          updates[cartItem.key] = 0;
        }
      });

      if (!Object.keys(updates).length) {
        window.location.assign(removeControl.href);
        return;
      }

      await requestJson(cartUpdateUrl(), { updates });
      window.location.reload();
    } catch (error) {
      row?.classList.remove('is-removing');
      removeControl.removeAttribute('aria-disabled');
      setCartError(error.message || '商品を削除できませんでした。もう一度お試しください。');
    }
  };

  const propertiesFor = (item, message = '') => {
    const properties = {
      _lusup_parent_key: item.dataset.parentKey || '',
      _lusup_unit_index: item.dataset.unitIndex || '1',
      _対象商品: item.dataset.parentTitle || '商品',
    };
    if (message) properties['メッセージカード'] = message;
    return properties;
  };

  const addGift = async (item) => {
    const root = getRoot(item);
    const toggle = item.querySelector(selectors.toggle);

    setError(item);

    if (!root || root.dataset.giftAvailable !== 'true' || !root.dataset.giftVariantId) {
      if (toggle) toggle.checked = false;
      setError(item, 'LUSUP Signature Giftは現在ご利用いただけません。');
      updateCheckoutState();
      return;
    }

    item.dataset.requestPending = 'true';
    setBusy(item, true);
    updateCheckoutState();

    try {
      await requestJson(cartAddUrl(), {
        items: [
          {
            id: root.dataset.giftVariantId,
            quantity: 1,
            properties: propertiesFor(item),
          },
        ],
      });
      window.location.reload();
    } catch (error) {
      if (toggle) toggle.checked = false;
      item.querySelector(selectors.messageChoice)?.setAttribute('hidden', '');
      item.dataset.requestPending = 'false';
      setBusy(item, false);
      setError(item, error.message || 'ギフトを追加できませんでした。');
      updateCheckoutState();
    }
  };

  const saveGift = async (item) => {
    const root = getRoot(item);
    const toggle = item.querySelector(selectors.toggle);
    const messageToggle = item.querySelector(selectors.messageToggle);
    const messageInput = item.querySelector(selectors.message);
    const message = messageInput?.value.trim() || '';

    setError(item);

    if (!toggle?.checked) {
      setError(item, 'LUSUP Signature Giftを選択してください。');
      return;
    }

    if (!messageToggle?.checked) {
      setError(item, 'メッセージカードを添える場合はチェックを入れてください。');
      return;
    }

    if (!message) {
      setError(item, 'メッセージをご入力ください。');
      messageInput?.focus();
      return;
    }

    if (hasUnsupportedCharacters(message)) {
      setError(item, '絵文字・一部の特殊記号は使用できません。');
      messageInput?.focus();
      return;
    }

    if (!root || root.dataset.giftAvailable !== 'true' || !root.dataset.giftVariantId) {
      setError(item, 'LUSUP Signature Giftは現在ご利用いただけません。');
      return;
    }

    item.dataset.requestPending = 'true';
    setBusy(item, true);
    updateCheckoutState();

    try {
      const properties = propertiesFor(item, message);
      const giftLineKey = item.dataset.giftLineKey || '';

      if (giftLineKey) {
        await requestJson(cartChangeUrl(), {
          id: giftLineKey,
          quantity: 1,
          properties,
        });
      } else {
        await requestJson(cartAddUrl(), {
          items: [
            {
              id: root.dataset.giftVariantId,
              quantity: 1,
              properties,
            },
          ],
        });
      }

      window.location.reload();
    } catch (error) {
      item.dataset.requestPending = 'false';
      setBusy(item, false);
      setError(item, error.message || 'カートを更新できませんでした。');
      updateCheckoutState();
    }
  };

  const removeGiftMessage = async (item, previousMessage = '') => {
    const giftLineKey = item.dataset.giftLineKey || '';
    if (!giftLineKey) return;

    item.dataset.requestPending = 'true';
    setBusy(item, true);
    updateCheckoutState();

    try {
      await requestJson(cartChangeUrl(), {
        id: giftLineKey,
        quantity: 1,
        properties: propertiesFor(item),
      });
      window.location.reload();
    } catch (error) {
      const messageToggle = item.querySelector(selectors.messageToggle);
      const message = item.querySelector(selectors.message);
      if (messageToggle) messageToggle.checked = true;
      if (message) message.value = previousMessage;
      item.dataset.requestPending = 'false';
      item.dataset.dirty = 'false';
      setBusy(item, false);
      setError(item, error.message || 'メッセージカードの設定を解除できませんでした。');
      syncMessageVisibility(item);
      updateCount(item);
      updateCheckoutState();
    }
  };

  const removeGift = async (item) => {
    const giftLineKey = item.dataset.giftLineKey || '';
    if (!giftLineKey) return;

    item.dataset.requestPending = 'true';
    setBusy(item, true);
    updateCheckoutState();

    try {
      await requestJson(cartChangeUrl(), { id: giftLineKey, quantity: 0 });
      window.location.reload();
    } catch (error) {
      const toggle = item.querySelector(selectors.toggle);
      if (toggle) toggle.checked = true;
      item.dataset.requestPending = 'false';
      setBusy(item, false);
      setError(item, error.message || 'ギフト設定を解除できませんでした。');
      syncMessageVisibility(item);
      updateCheckoutState();
    }
  };

  const updateCartCountBubble = (cart, giftHandle) => {
    const visibleItemCount = cart.items.reduce((count, item) => {
      const isLinkedGift = item.handle === giftHandle && item.properties?._lusup_parent_key;
      return isLinkedGift ? count : count + item.quantity;
    }, 0);
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');
    if (visibleItemCount < 1) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartIcon.appendChild(bubble);
    }

    const visibleCount = document.createElement('span');
    visibleCount.setAttribute('aria-hidden', 'true');
    if (visibleItemCount < 100) visibleCount.textContent = String(visibleItemCount);

    const accessibleCount = document.createElement('span');
    accessibleCount.className = 'visually-hidden';
    accessibleCount.textContent = `カート内の商品数：${visibleItemCount}`;
    bubble.replaceChildren(visibleCount, accessibleCount);
  };

  const cleanupLinkedGifts = async (root) => {
    if (!root || root.dataset.cartGiftCleanupStarted === 'true') return;
    root.dataset.cartGiftCleanupStarted = 'true';

    try {
      const response = await fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const giftHandle = root.dataset.giftProductHandle;
      updateCartCountBubble(cart, giftHandle);
      const parents = new Map(
        cart.items.filter((item) => item.handle !== giftHandle).map((item) => [item.key, item])
      );
      const seenPairs = new Set();
      const updates = {};

      cart.items.forEach((item) => {
        if (item.handle !== giftHandle) return;
        const properties = item.properties || {};
        const parentKey = properties._lusup_parent_key;
        if (!parentKey) return;

        const unitIndex = Number.parseInt(properties._lusup_unit_index, 10);
        const parent = parents.get(parentKey);
        const pairKey = `${parentKey}::${unitIndex}`;
        const isValid =
          parent &&
          Number.isFinite(unitIndex) &&
          unitIndex > 0 &&
          unitIndex <= parent.quantity &&
          !seenPairs.has(pairKey);

        if (!isValid) {
          updates[item.key] = 0;
          return;
        }

        seenPairs.add(pairKey);
        if (item.quantity !== 1) updates[item.key] = 1;
      });

      const updateKeys = Object.keys(updates);
      if (!updateKeys.length) {
        sessionStorage.removeItem('lusupCartGiftCleanup');
        return;
      }

      const cleanupSignature = updateKeys.sort().map((key) => `${key}:${updates[key]}`).join('|');
      if (sessionStorage.getItem('lusupCartGiftCleanup') === cleanupSignature) return;
      sessionStorage.setItem('lusupCartGiftCleanup', cleanupSignature);

      await requestJson(cartUpdateUrl(), { updates });
      window.location.reload();
    } catch (error) {
      console.warn('LUSUP Signature Giftの関連付けを確認できませんでした。', error);
    }
  };

  const initialize = () => {
    document.querySelectorAll(selectors.item).forEach((item) => {
      syncMessageVisibility(item);
      updateCount(item);
    });
    updateCheckoutState();
    document.querySelectorAll(selectors.root).forEach(cleanupLinkedGifts);
  };

  document.addEventListener('change', (event) => {
    const giftControl = event.target.closest(`${selectors.toggle}, ${selectors.messageToggle}, ${selectors.message}`);
    if (!giftControl) return;

    event.stopPropagation();
    setCartError();

    const toggle = event.target.closest(selectors.toggle);
    if (toggle) {
      const item = getItem(toggle);
      if (!item) return;

      setError(item);

      if (toggle.checked) {
        syncMessageVisibility(item);
        item.dataset.dirty = 'false';
        updateCheckoutState();
        if (!item.dataset.giftLineKey) addGift(item);
        return;
      }

      item.dataset.dirty = 'false';
      syncMessageVisibility(item);
      updateCheckoutState();

      if (item.dataset.giftLineKey) {
        removeGift(item);
        return;
      }

      const messageToggle = item.querySelector(selectors.messageToggle);
      const message = item.querySelector(selectors.message);
      if (messageToggle) messageToggle.checked = false;
      if (message) message.value = '';
      updateCount(item);
      return;
    }

    const messageToggle = event.target.closest(selectors.messageToggle);
    if (!messageToggle) return;

    const item = getItem(messageToggle);
    if (!item) return;

    const message = item.querySelector(selectors.message);
    setError(item);

    if (messageToggle.checked) {
      item.dataset.dirty = 'true';
      syncMessageVisibility(item);
      updateCount(item);
      if (!message?.value.trim()) message?.focus();
      updateCheckoutState();
      return;
    }

    const previousMessage = message?.value || '';
    if (message) message.value = '';
    item.dataset.dirty = 'false';
    syncMessageVisibility(item);
    updateCount(item);
    updateCheckoutState();

    if (item.dataset.giftLineKey) removeGiftMessage(item, previousMessage);
  }, true);

  document.addEventListener('input', (event) => {
    const message = event.target.closest(selectors.message);
    if (!message) return;

    const item = getItem(message);
    if (!item) return;
    item.dataset.dirty = 'true';
    setError(item);
    updateCount(item);
    updateCheckoutState();
  });

  document.addEventListener('click', (event) => {
    const removeControl = event.target.closest(selectors.removeProduct);
    if (removeControl) {
      event.preventDefault();
      event.stopImmediatePropagation();
      removeParentProduct(removeControl);
      return;
    }

    const modalClose = event.target.closest(selectors.modalClose);
    if (modalClose) {
      event.preventDefault();
      closeDialog(modalClose.closest('dialog'));
      return;
    }

    const infoOpen = event.target.closest(selectors.infoOpen);
    if (infoOpen) {
      event.preventDefault();
      openDialog(document.querySelector(selectors.infoDialog));
      return;
    }

    const paymentGuard = event.target.closest(selectors.paymentGuard);
    if (paymentGuard) {
      event.preventDefault();
      event.stopImmediatePropagation();
      guardCheckout();
      return;
    }

    const saveButton = event.target.closest(selectors.save);
    if (saveButton) {
      event.preventDefault();
      saveGift(getItem(saveButton));
      return;
    }

    const checkoutButton = event.target.closest(checkoutSelector);
    if (checkoutButton && guardCheckout()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('#cart') || !guardCheckout()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.matches('.cart-gift-modal')) closeDialog(event.target);
  });

  let initializeTimer = 0;
  const scheduleInitialize = () => {
    window.clearTimeout(initializeTimer);
    initializeTimer = window.setTimeout(initialize, 0);
  };

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) {
      scheduleInitialize();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialize();
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    initialize();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
